<script setup>
import { computed, ref } from 'vue'
import IconBase from '../icon/IconBase.vue';
import IconInfo from '../icon/IconInfo.vue';
import IconAlertTriangle from '../icon/IconAlertTriangle.vue';
import IconError from '../icon/IconError.vue';
import FormButton from './FormButton.vue';
import IconCross from '../icon/IconCross.vue';

const isVisible = ref(true)

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  },
  hideIcon: {
    type: Boolean,
    default: false
  },
  closeIcon: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'normal'
  },
  text: {
    type: String,
    default: '',
  }
})

const toggleView = () => {
  isVisible.value = !isVisible.value
}
const computedClass = computed(() => {
  switch (props.type) {
    case 'normal':
      return 'bg-surface-3 text-surface-8'
      case 'surface-2':
      return 'bg-surface-2 text-surface-8'
    case 'error':
    case 'errwarning':
      return 'bg-error text-white'
    case 'warning':
      return '!bg-warning text-white'
    case 'warning2':
      return 'alert-warning'
    default: return ''
  }
})
const computedIcon = computed(() => {
  switch (props.type) {
    case 'normal':
    case 'surface-2':
      return IconInfo
    case 'error':
      return IconError
    case 'warning':
    case 'warning2':
      return IconAlertTriangle
    case 'errwarning':
      return IconAlertTriangle
    default: return
  }
})
defineExpose({ toggleView, isVisible })
</script>
<template>
  <Transition name="collapse">
    <section class="collapse-wrapper flex text-tiny !pl-2 !py-2 rounded-md leading-4 relative" :class="[computedClass, closeIcon? '!pr-8': '!pr-2']" v-if="isVisible">
      <icon-base v-if="!hideIcon" class="shrink-0 text-surface-8 !mr-2" :class="{ '!text-white': props.type === 'errwarning' || props.type === 'warning' || props.type === 'warning2' || props.type === 'error' }">
        <component :is="computedIcon" />
      </icon-base>
      {{ text }}
      <slot />
      <FormButton type="link" size="sm" is-icon v-if="closeIcon" @click="toggleView" class="absolute right-1 top-[2px] z-10">
        <icon-base class="shrink-0 text-surface-8">
          <IconCross />
        </icon-base>
      </FormButton>
    </section>
  </Transition>
</template>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.alert-warning {
  background-color: var(--c-warning-bg);
  border-width: 0 0 0 6px;
  border-color: var(--c-warning);
  border-radius: 6px;
  color: #fff;
}
</style>